<template>
    <admin-dashboard-layout>
        <v-data-table
            :search="search"
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="moderator"
            :items-per-page="quantityItems"
            class="elevation-1"
            @click:row="handleClickRow"
        >
            <template v-slot:top>
                <v-text-field
                    v-model="search"
                    label="Search"
                    class="mx-4"
                ></v-text-field>
            </template>
            <template v-slot:item.balance="{ item }">
                {{ item.balance }}{{ currency }}
            </template>
        </v-data-table>
    </admin-dashboard-layout>
</template>

<script>
import ModeratorRequests from "../../../models/admin/ModeratorRequest.js";
import AdminDashboardLayout from "../../../layouts/AdminDashboardLayout";
import {
    ADMIN_QUANTITY_ITEMS_LIST
} from "../../../configs/constants";
import { mapMutations } from "vuex";

export default {
    name: "moderator-requests-index",
    components: { AdminDashboardLayout },
    data: function () {
        return {
            loading: false,
            moderator: [],
            quantityItems: ADMIN_QUANTITY_ITEMS_LIST,
            search: "",
            headers: [
                {
                    text: "# ID",
                    align: "start",
                    sortable: false,
                    value: "id",
                },
                { text: "Name", value: "creator.user.name" },
                { text: "Status", value: "status" },
                // { text: "Wallet Balance", value: "balance" },
            ],
        }
    },
    methods: {
        ...mapMutations(["showSnackBar"]),
        handleClickRow(moderator) {
            this.$router.push({
                name: "admin.moderator-requests.show",
                params: { id: moderator.id},
            });
        }
    },
    async mounted() {
        this.loading = true;
        this.moderator = await ModeratorRequests.get();
        this.loading = false;
    },
}
</script>

<style scoped></style>